import i18n, { Resource } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { Settings } from 'luxon'
import { initReactI18next } from 'react-i18next'
import de from './de.json'
import en from './en.json'
import fr from './fr.json'
import it from './it.json'
import it_CH from './it_CH.json'
import de_CH from './de_CH.json'
import { getDomainExtension } from '@utils/getDomainExtension'

function getLang() {
    if (typeof navigator.languages !== 'undefined') return navigator.languages[0]
    return navigator.language
}

const resources = (): Resource => {
    // for swiss domains we use the swiss translations
    const domain = getDomainExtension()
    if (domain === 'ch') {
        return {
            de: de_CH,
            'de-DE': de_CH,
            en,
            fr,
            it,
            'de-CH': de_CH,
            'it-CH': it_CH
        }
    }
    return {
        de,
        'de-DE': de,
        en,
        fr,
        it,
        'it-it': it,
        'de-CH': de_CH,
        'it-CH': it_CH
    }
}

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: resources(),
        supportedLngs: ['de', 'de-DE', 'en', 'fr', 'it', 'de-CH', 'it-CH'],
        detection: { order: ['localStorage', 'navigator'] },
        ns: [
            'common',
            'errors',
            'footer',
            'header',
            'languages',
            'home',
            'checkout',
            'contact',
            'guidelines',
            'faq',
            'lot',
            'notFound',
            'policy',
            'search',
            'days',
            'lpInput',
            'profile',
            'login',
            'register',
            '404',
            'faq',
            'bookings',
            'subscriptions',
            'invoice',
            'carpay',
            'accountCreationAd',
            'occupancy',
            'seo',
            'landingPages',
            'guest'
        ],
        defaultNS: 'common',
        nsSeparator: '.',
        fallbackLng: (code: string) => {
            const defaultLang = 'de-DE'
            const fallbacks: string[] = []

            if (!code) return [defaultLang]

            if (code.startsWith('en')) fallbacks.push('en')
            if (code.startsWith('fr')) fallbacks.push('fr')
            if (code.startsWith('it')) fallbacks.push('it')
            if (code.startsWith('de-CH')) fallbacks.push('de-CH')
            if (code.startsWith('it-CH')) fallbacks.push('it-CH')

            if (fallbacks.length === 0) return [defaultLang]

            return fallbacks
        },
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false
        },
        returnObjects: true,
        react: {
            bindI18n: 'languageChanged'
        }
    })

Settings.defaultLocale = getLang()

export default i18n
